import type { Dispatch, SetStateAction, ReactNode } from 'react';
import { CardPaymentForm, emptyCard, emptyHolderInfo } from '@/features/subscription/components/CardPaymentForm';
import { AutoChargeCheckbox } from '@/features/subscription/components/AutoChargeCheckbox';
import type { DiscountInfo } from '@/features/subscription/components/PromoCodeInput';

interface CardFormStepProps {
  planName: string;
  valueCents: number;
  card: typeof emptyCard;
  setCard: Dispatch<SetStateAction<typeof emptyCard>>;
  holderInfo: typeof emptyHolderInfo;
  setHolderInfo: Dispatch<SetStateAction<typeof emptyHolderInfo>>;
  autoChargeExcess: boolean;
  setAutoChargeExcess: (value: boolean) => void;
  error: string | null;
  isPending: boolean;
  onSubmit: () => void;
  onBack: () => void;
  discount?: DiscountInfo | null;
  promoCodeSlot?: ReactNode;
}

export function CardFormStep({
  planName,
  valueCents,
  card,
  setCard,
  holderInfo,
  setHolderInfo,
  autoChargeExcess,
  setAutoChargeExcess,
  error,
  isPending,
  onSubmit,
  onBack,
  discount,
  promoCodeSlot,
}: CardFormStepProps) {
  return (
    <div className="space-y-4">
      <CardPaymentForm
        planName={planName}
        valueCents={valueCents}
        card={card}
        setCard={setCard}
        holderInfo={holderInfo}
        setHolderInfo={setHolderInfo}
        error={error}
        isPending={isPending}
        onBack={onBack}
        onSubmit={onSubmit}
        wide
        discount={discount}
        footer={<AutoChargeCheckbox checked={autoChargeExcess} onChange={setAutoChargeExcess} />}
        promoCodeSlot={promoCodeSlot}
      />
    </div>
  );
}
